import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  AfterViewInit,
  Renderer2, ElementRef 
} from "@angular/core";
import { WeightItemService } from '../../../services/weightitem.service';

declare var $: any;

declare interface option {
  colName: string;
  position: number;
  visibility: boolean;
  origin: number;
}

@Component({
  selector: "data-table",
  templateUrl: "./tablas.component.html",
  styleUrls: ["./tablas.component.css"],
})
export class TablasComponent implements OnInit, AfterViewInit {
  @Input() ref: string = "dataTable";
  @Input() id: string = "dataTable";
  @Input() r: any;
  @Input() options: Array<option> = [];
  @Input() esbusqueda = false;
  @Input() btnExcel = true;
  @Input() btnPDF = true;
  @Input() btnPrint = true;
  @Input() btnCol = true;
  @Input() frontpaginate = false;
  @Input() cleanbulk = false;
  @Input() personalButtons: Array<any> = [];
  @Input() campoBusqueda = "";
  @Input() bulk: number[] = [];
  @Input() dateColumns: number[] = [];
  @Input() is_table_saved: boolean = false;
  @Output() output: EventEmitter<any>;
  @Output() changeBulk: EventEmitter<any>;
  @Output() buscar: EventEmitter<any>;
  @Output() newOptions: EventEmitter<any>;

  public data: Array<any> = [];

  public items_per_page = "10";
  public page_actual = 1;
  public total_items_count = 0;
  public total_pages = 1;

  public showingTo = 0;
  public showingNav = 0;
  public pages = [];
  public wh = 'Please wait...';

  public token;

  public paginar = {
    page: 1,
    perpage: "10",
    search: "",
    esbusqueda: false,
    sortby: "",
    sort: "", //ASC - DESC
  };

  constructor(private renderer: Renderer2, private el: ElementRef, private weightService: WeightItemService) {
    this.changeBulk = new EventEmitter();
    this.output = new EventEmitter();
    this.buscar = new EventEmitter();
    this.newOptions = new EventEmitter();
    this.token = JSON.parse(localStorage.getItem("token"));


  }

  ngOnInit() {
     console.log("ngOnInit => this.options => ", this.options);
    if (this.btnExcel) {
      this.personalButtons.push({
        extend: "excel",
        text: '<i class="fa fa-file-excel-o"></i>',
        titleAttr: "Excel",
        className: "btn btn-sm btn-outline-success",
        exportOptions: {
          columns: ":visible",
        },
      });
    }

    if (this.btnPDF) {
      this.personalButtons.push({
        extend: "pdf",
        text: '<i class="fa fa-file-pdf-o"></i>',
        titleAttr: "PDF",
        className: "btn btn-sm btn-outline-danger",
        exportOptions: {
          columns: ":visible",
        },
      });
    }

    if (this.btnPrint) {
      this.personalButtons.push({
        extend: "print",
        text: '<i class="fa fa-print" aria-hidden="true"></i>',
        titleAttr: "print",
        className: "btn btn-sm btn-outline-primary",
        exportOptions: {
          columns: ":visible",
        },
      });
    }

    if (this.btnCol) {
      this.personalButtons.push({
        extend: "colvis",
        text: '<i class="fa fa-columns" aria-hidden="true"></i>',
        className: "btn btn-sm btn-outline-info",
        titleAttr: "Column visibility",
      });
    }

    console.log(this.r);
    if (this.r.code === 200) {
      this.data = this.r.data;
      console.log("this data", this.r);
      this.items_per_page = String(this.r.items_per_page);
      this.paginar.perpage = String(this.r.items_per_page);
      this.paginar.sort = this.r.order;
      this.paginar.sortby = this.r.orderby;
      this.page_actual = this.r.page_actual;
      this.total_items_count = this.r.total_items_count;
      this.total_pages = this.r.total_pages;

      this.showingTo = this.r.page_actual * this.r.items_per_page;
      this.showingNav =
        this.r.page_actual * this.r.items_per_page -
        (this.r.items_per_page - 1);

      let valorfor = this.page_actual - 2;
      if (valorfor < 0) {
        valorfor = 0;
      }
      this.pages = [];
      let cont = 0;
      for (let i = valorfor; i < this.r.total_pages; i++) {
        let vaalortest = this.page_actual - i;
        // console.log(vaalortest);
        this.pages.push(i);
        cont++;
        if (cont > 5) {
          break;
        }
      }

      this.paginar.search = this.campoBusqueda;
      this.paginar.esbusqueda = this.esbusqueda;
    }
  }

  cleanBulk() {
    console.log('Limpiando!');
    this.bulk = [];
    this.changeBulk.emit([]);
  }

  send(e) {
    this.output.emit(e);
  }

  search() {
    this.cleanBulk();
    this.paginar.page = 1;
    this.paginar.search = this.campoBusqueda;
    this.paginar.esbusqueda = true;
    this.goToPage(1);
  }

  restoreTable() {
    this.cleanBulk();
    this.paginar.page = 1;
    this.paginar.search = "";
    this.campoBusqueda = "";
    this.paginar.sortby = "";
    this.paginar.sort = "";
    this.esbusqueda = false;
    this.paginar.esbusqueda = false;
    this.goToPage(1);
  }

  sort(e) {
    this.paginar.sortby = e.sortby;
    this.paginar.sort = e.sort;
    this.goToPage(1);
  }

  changeLimit() {
    this.paginar.page = 1;
    this.paginar.perpage = this.items_per_page;
    this.goToPage(1);
  }

  goToPage(page) {
    this.paginar.page = page;
    this.buscar.emit(this.paginar);
  }

  setBulk(e) {
    this.bulk = e;
    this.changeBulk.emit(e);
  }

  setOptions(e) {
    this.newOptions.emit(e);
  }

  ngAfterViewInit() {
    let visibility = [];
    for (let option of this.options) {
      if (!option.visibility) {
        visibility.push(option.origin);
      }
    }

    let positions = [];
    while (positions.length < this.options.length) {
      for (let option of this.options) {
        if (option.position === positions.length) {
          positions.push(option.origin);
          break;
        }
      }
    }

   

    let configuraciones = this.frontpaginate ?
    {
      colReorder: positions.length !== 0 ? {
        order: positions
      } : true,
      columnDefs: [
        { targets: visibility, visible: false },
        { targets: this.dateColumns, type: "date" },
      ],
      order: this.sort,
      dom: 'Bflrtip',
      buttons: [
        this.personalButtons
      ],
      'pagingType': 'full_numbers',
      'lengthMenu': [
        [10, 25, 50, 100, 200, 500, 1000, -1],
        [10, 25, 50, 100, 200, 500, 1000, 'All']
      ],
      // responsive: true,
      // scrollY: '645px',
      scrollX: true,
      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search records',
      }

    }
    :
    {
      colReorder: positions.length !== 0 ? {
        order: positions
      } : true,
      columnDefs: [
        { targets: visibility, visible: false },
        { targets: this.dateColumns, type: "date" },
      ],
      bInfo: false,
      ordering: false,
      searching: false,
      paging: false,
      dom: 'Bflrtip',
      buttons: [
        this.personalButtons
      ],
      // responsive: true,
      // scrollY: '645px',
      scrollX: true,
      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search records',
      }

    };

    let table = $("#" + this.id).DataTable(configuraciones);

    table.on("click", ".emitir", (e) => {
      let res = e.target.id.split("-");
      const item = this.data.find((element) => element.id == res[1]);
      this.send({ evento: res[0], id: res[1], item });
    });

    table.on(
      "column-reorder",
      function (e, settings, details) {
        for (let col of settings.aoColumns) {
          for (let option of this.options) {
            if (option.origin === col._ColReorder_iOrigCol) {
              option.position = col.idx;
              break;
            }
          }
        }
        this.newOptions.emit(this.options);
      }.bind(this)
    );

    table.on(
      "column-visibility.dt",
      function (e, settings, column, state) {
        for (let option of this.options) {
          if (option.position === column) {
            option.visibility = state;
            break;
          }
        }
        this.newOptions.emit(this.options);
      }.bind(this)
    );




    // Get all elements with the specific classname within this component
    const elementosContainers = this.el.nativeElement.querySelectorAll('.toolverificar');
    console.log("this.options.length => ", this.options.length);
    console.log("this.options => ", this.options);
if(this.is_table_saved){
    elementosContainers.forEach(contenedor_id => {
  this.renderer.listen(contenedor_id, 'mouseover', (event) => {

    console.log(" event => ", event);
    console.log(" event.target.value => ", event.target.value );
    
    const dataAttribute = contenedor_id.getAttribute('data-attr');
    console.log("dataAttribute => ", dataAttribute);

   

    this.wh = 'Please rehover the mouse...';
    this.weightService.getItem(this.token, dataAttribute).subscribe(
      r => {
        if (r.status === "success") {
          console.log(r.data);
          this.wh = r.data.internalLocation !== null ? ( r.data.internalLocation.location ? r.data.internalLocation.location.name + ' - ' + r.data.internalLocation.locationName + ': ' + r.data.internalLocation.locationRow +
          '-' + r.data.internalLocation.locationBay + '-' + r.data.internalLocation.locationLevel +
          '-' + r.data.internalLocation.locationSection : null ) : null;
          console.log("this.wh => ", this.wh);

          contenedor_id.setAttribute('title', this.wh);
           //$('*[data-interno="'+dataAttribute+'"]').addClass("tooltipshow");
          $('*[data-interno="'+dataAttribute+'"]').text(this.wh);
        }
        

       

       
      }
    );
  

  });

  this.renderer.listen(contenedor_id, 'mouseout', (event) => {

   
    
    const dataAttribute = contenedor_id.getAttribute('data-attr');
   
   

 // $('*[data-interno="'+dataAttribute+'"]').removeClass("tooltipshow");
 // $('*[data-interno="'+dataAttribute+'"]').addClass("tooltiphide");

  });

    });
}


  }
}
